"use client";
import NextLink from "next/link";
import { usePathname } from "next/navigation";

type Props = {
	text: string;
	href: string;
};

export const HeaderLinkButton = (props: Props) => {
	const pathname = usePathname();
	const is2024techfes = pathname?.endsWith("events/2024techfes/detail");

	const bgColor = is2024techfes ? "bg-white" : "bg-black";
	const fontColor = is2024techfes ? "text-black" : "text-white";

	return (
		<NextLink
			href={props.href}
			className={`px-4 py-2 rounded-md ${bgColor} ${fontColor} text-sm`}
			target={"_blank"}
			rel={"noopener noreferrer"}
		>
			{props.text}
		</NextLink>
	);
};
